export const ERROR_KEYS = {
    TEAMS: {
        FAILED_TO_DELETE: "Failed to delete team.",
        FAILED_TO_UPDATE: "Failed to update team.",
        FAILED_TO_CREATE: "Failed to create team."
    },
    ACCESS_LIST: {
        PROCESS_FAILED: "Failed to process access list.",
        FETCH_FAILED: "Failed to fetch user groups for access list."
    },
    ACCESS_GRANT: {
        // Two distinct failure modes, kept as separate keys so DataDog does not group a role-link
        // resolution conflict together with a plain configuration gap.
        AMBIGUOUS_PRODUCT_GROUP: "Could not resolve the product group for the selected role.",
        NO_PRODUCT_GROUP: "No product group offers the selected role on the selected instance."
    }
};
